"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("@atlaskit/button"));

var _default = function _default(props) {
  return _react.default.createElement(_button.default, {
    appearance: "subtle",
    onClick: props.onClick,
    spacing: "none",
    tabIndex: -1,
    iconBefore: props.children
  });
};

exports.default = _default;